export const iconFontAwesomeMedicalHealthHeartCircleExclamation = (
	<i className="fa-solid fa-heart-circle-exclamation"></i>
);
